import { render, staticRenderFns } from "./SyncCourseTeachers.vue?vue&type=template&id=1659cf46"
import script from "./SyncCourseTeachers.vue?vue&type=script&lang=js"
export * from "./SyncCourseTeachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports